import { apiClient } from "./client";

// ---- Institution officers ----

export async function listInstitutionOfficers() {
  const res = await apiClient.get("/institution/officers");
  return res.data;
}

export async function inviteInstitutionOfficer(dto) {
  const res = await apiClient.post("/institution/officers", dto);
  return res.data;
}

export async function disableInstitutionOfficer(id) {
  const res = await apiClient.post(`/institution/officers/${id}/disable`, {});
  return res.data;
}

export async function promoteInstitutionOfficer(id) {
  const res = await apiClient.post(`/institution/officers/${id}/promote`, {});
  return res.data;
}

export async function resendInstitutionOfficerInvite(id) {
  const res = await apiClient.post(
    `/institution/officers/${id}/resend-invite`,
    {},
  );
  return res.data;
}

export async function getInstitutionHiringQuota(isOrganisation = false) {
  const url = isOrganisation
    ? "/organisation/officers/quota"
    : "/institution/officers/quota";
  const res = await apiClient.get(url);
  return res.data;
}

export async function initiateAdditionalOfficerPurchase(
  dto,
  isOrganisation = false,
) {
  const url = isOrganisation
    ? "/organisation/officers/initiate-additional-purchase"
    : "/institution/officers/initiate-additional-purchase";
  const res = await apiClient.post(url, dto);
  return res.data;
}

export async function validateInstitutionInvite(token) {
  const res = await apiClient.get(
    `/institution/invites/validate?token=${encodeURIComponent(token)}`,
  );
  return res.data;
}

export async function acceptInstitutionInvite(dto) {
  const res = await apiClient.post("/institution/invites/accept", dto);
  return res.data;
}

// ---- Organisation officers ----

export async function listOrganisationOfficers() {
  const res = await apiClient.get("/organisation/officers");
  return res.data;
}

export async function inviteOrganisationOfficer(dto) {
  const res = await apiClient.post("/organisation/officers", dto);
  return res.data;
}

export async function disableOrganisationOfficer(id) {
  const res = await apiClient.post(`/organisation/officers/${id}/disable`, {});
  return res.data;
}

/** Sets the branch an organisation officer works at; null clears it. */
export async function setOrganisationOfficerBranch(id, branchId) {
  const res = await apiClient.post(`/organisation/officers/${id}/branch`, {
    branchId,
  });
  return res.data;
}

export async function promoteOrganisationOfficer(id) {
  const res = await apiClient.post(`/organisation/officers/${id}/promote`, {});
  return res.data;
}

// ---- Multi-Officer Join Requests ----

export async function listJoinRequests(organisationId) {
  const res = await apiClient.get(
    `/organisation/${organisationId}/join-requests`,
  );
  return res.data;
}

export async function approveJoinRequest(organisationId, requestId) {
  const res = await apiClient.post(
    `/organisation/${organisationId}/join-request/${requestId}/approve`,
    {},
  );
  return res.data;
}

// The server's field is rejectionReason (organisations/dto/join-request.dto.ts)
// and it refuses unknown keys, so a reason under any other name fails with 400.
export async function rejectJoinRequest(organisationId, requestId, reason) {
  const res = await apiClient.post(
    `/organisation/${organisationId}/join-request/${requestId}/reject`,
    { rejectionReason: reason || undefined },
  );
  return res.data;
}

// ---- Token-Based Colleague Invites ----

export async function createOrgInvite(organisationId, dto) {
  const res = await apiClient.post(
    `/organisation/${organisationId}/invite`,
    dto,
  );
  return res.data;
}

/** The organisation's invitations still waiting to be accepted. */
export async function listOrganisationInvites(organisationId) {
  const res = await apiClient.get(`/organisations/${organisationId}/invites`);
  return res.data;
}

/** Emails a new link (72 hours); the earlier one stops working. */
export async function resendOrganisationInvite(organisationId, inviteId) {
  const res = await apiClient.post(
    `/organisations/${organisationId}/invites/${inviteId}/resend`,
    {},
  );
  return res.data;
}

/** Withdraws an invitation; its link stops working. */
export async function revokeOrganisationInvite(organisationId, inviteId) {
  const res = await apiClient.post(
    `/organisations/${organisationId}/invites/${inviteId}/revoke`,
    {},
  );
  return res.data;
}

export async function validateInviteToken(token) {
  const res = await apiClient.get(
    `/organisations/invites/validate?token=${encodeURIComponent(token)}`,
  );
  return res.data;
}

export async function acceptOrgInvite(dto) {
  const res = await apiClient.post("/organisations/invites/accept", dto);
  return res.data;
}
